import React from 'react'

import {
  ISpotlightList as IContentfulSpotlightList,
  ISpotlightListItem as IContentfulSpotlightListItem,
} from 'marketing-site/@types/generated/contentful'
import {
  SpotlightList,
  IProps as ISpotlightList,
  ISpotlightListItem,
} from 'marketing-site/src/library/components/SpotlightList'
import { transformCTAWithBackground } from '../elements/ContentfulCTALink'
import { transformImage } from '../elements/ContentfulImage'

export function ContentfulSpotlightList(props: IContentfulSpotlightList) {
  return <SpotlightList {...transformSpotlightList(props)} />
}

function transformSpotlightList({ fields }: IContentfulSpotlightList): ISpotlightList {
  return {
    ...fields,
    listItems: fields.listItems.map(transformSpotlightListItem),
  }
}

function transformSpotlightListItem({ fields }: IContentfulSpotlightListItem): ISpotlightListItem {
  return {
    ...fields,
    image: transformImage(fields.image),
    cta: transformCTAWithBackground(fields.ctaLink),
  }
}
